import React, { useEffect, useState } from 'react'
import "./enquiryForm.css"
import { Modal } from 'react-bootstrap'
import PI from "react-phone-input-2";
import useGeoLocation from "react-ipgeolocation";
import "./enquiryForm.css"
import "react-phone-input-2/lib/style.css";
import PhoneInput from 'react-phone-input-2';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

const EnquiryForm = ({setEnquiryPopUp, title='Enquire Now'}) => {

    const ReactPhoneInput = PI.default ? PI.default : PI;
    const history = useHistory()

    const location = useGeoLocation();
    const [isDisable, setisDisable] = useState(true);
    const [countrycode, setCountryCode] = useState(undefined);
    const [phoneNo,setPhoneNo] = useState(null)

    const handleChange = (value, data, event, formattedValue) => {
        const mobile = value.slice(data.dialCode.length)
        setPhoneNo(mobile)
        setEbookDownload((prev) => ({ ...prev, mobile, isd: data.dialCode}))

    };

    const [EbookDownload, setEbookDownload] = useState({
        name: "",
        emailId: "",
        mobile: "",
        isd: '',
        session:''
    });



    useEffect(() => {
        if(EbookDownload.name && EbookDownload.emailId && EbookDownload.mobile.length >= 5 && EbookDownload.session)
        {
          setisDisable(false)
        }
        else{
          setisDisable(true)
        }
    }, [EbookDownload.name && EbookDownload.emailId && EbookDownload.mobile && EbookDownload.session])


    const handleEnquiry = () => {

        // const privyrData = {
        //     email: EbookDownload.emailId,
        //     name: EbookDownload.name,
        //     mobile: EbookDownload.mobile,
        //     isd: EbookDownload.isd,
        //     lead_source: EbookDownload.session
        // }

        // let config = {
        //     method: 'post',
        //     maxBodyLength: Infinity,
        //     url: 'https://www.privyr.com/integrations/api/v1/incoming-webhook',
        //     headers: { 
        //       'X-TOKEN': 'hp4iWYK7', 
        //     //   'X-TOKEN': 'ACRXGO9m', 
        //       'Content-Type': 'application/json'
        //     },
        //     data : privyrData
        //   };
          
        //   axios.request(config)
        //   .then((response) => {
        //     console.log(response)
        //     console.log(JSON.stringify(response.data));
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });

        TeleCRMLeads()

          const NewFormData = {
            email: EbookDownload.emailId,
            name: EbookDownload.name,
            mobile: EbookDownload.mobile,
            isd: EbookDownload.isd, 
            campaignId: process.env.REACT_APP_CAMPAIGNID, 
            packageId: process.env.REACT_APP_PACKAGE_ID,
            originCampaign:EbookDownload.session,
        }
        const SubmitNewFormData = JSON.stringify(NewFormData)

        axios.post('https://ser.ay.tudotechnologies.com/magicFood/registerUserPayNow/', 
        // axios.post('https://qrs.btartisticyoga.com/magicFood/registerUserPayNow/', 
            SubmitNewFormData,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
        .then((res) => {
            console.log("Register User",res)
            setisDisable(false)
                setEbookDownload((prevState) => ({
                    ...prevState,
                })); 
            history.push("/ThankyouPage")
        })
        .catch((err) => {
            console.log(err)
            alert("Something went wrong. Please try again later.")
            setisDisable(false)
        });
    }


    const TeleCRMLeads = async () => {

        const hostName = window.location.hostname
        const url = `https://api.telecrm.in/enterprise/688c705178fd22989f75ecef/autoupdatelead`;
        const token = 'c2b2c8c2-102b-47e8-b491-1db5763080421754305303538:aa287813-6838-442c-a5d8-4f247b99e32f'
        const params = new URLSearchParams(window.location.search);

        const data = {
            fields: {
            name: EbookDownload.name,
            phone: `${EbookDownload.isd}-${EbookDownload.mobile}`,
            email: EbookDownload.emailId,
            utm_source: params.get("utm_source") || "",
            utm_medium: params.get("utm_medium") || "",
            utm_campaign: params.get("utm_campaign") || "",
            utm_content: params.get("utm_content") || "",
            gclid: params.get("gclid") || "",
            },
            actions: [
            {
                type: "SYSTEM_NOTE",
                text: `Lead Source: Studio Page - Enquire Now (${hostName})`
            }
            ]
        };

        const config = {
            headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
            }
        };

        try {
            const response = await axios.post(url, data, config);
            return response.data;
        } catch (error) {
            console.error("Error updating lead:", error);
            throw error;
        }
    }


  return (
    <div className='EbookPopUp'>
    <Modal
    className='EbookModal'
    show={true}
    // size='md'
    backdrop='static'
    keyboard={false}
    aria-labelledby='contained-modal-title-vcenter'
    centered>
        <Modal.Body className="p-0">
        <div className='congratulations pt-4'>
        <div className='header'>
            <div className='px-5 d-flex align-items-center justify-content-center position-relative'>
                <h1 className='title'>{title}</h1>
                <p
                    onClick={() => {
                        setEnquiryPopUp(false);
                    }}
                    className='position-absolute'
                    style={{ right: 0, top: 0, paddingRight: "24px" }}>
                    <img
                        src='assets/close.svg'
                        alt=''
                        className='img-fluid'
                    />
                </p>
            </div>
        </div>
        <div className='px-4 '>
            <div className='d-flex flex-column mt-3'>
                <label htmlFor='Name'>Name</label>
                <input
                    // onChange={handleFormData}
                    placeholder='Enter your name'
                    type='text'
                    id='Name'
                    name='name'
                    onChange={(e) => setEbookDownload((prev) => {
                        return { ...prev, name: e.target.value }
                    })}
                />
            </div>
            <div className='d-flex flex-column mt-3'>
                <label htmlFor='Email'>Email Address</label>
                <input
                     onChange={(e) => setEbookDownload((prev) => {
                        return { ...prev, emailId: e.target.value }
                    })}
                    name='emailId'
                    placeholder='Enter your email'
                    type='email'
                    id='Email'
                />
            </div>
        
            <div className='d-flex flex-column mt-3'>
                <label htmlFor="email">Phone No</label>
                <PhoneInput
                    className="joinNowinput"
                    onChange={handleChange}
                    placeholder='Enter your mobile'
                    type='text'
                    id='Mobile'
                    country={'ae'}
                />
            </div>

            <div className='d-flex flex-column mt-3'>
                <label htmlFor='Email'>Preferred mode of class</label>
                <select
                     onChange={(e) => setEbookDownload((prev) => {
                        return { ...prev, session: e.target.value }
                    })}
                    name='session'
                    placeholder='Select a session'
                    id='Session'
                >
                    <option value="" selected disabled>Select a session</option>
                    <option value="Studio Session">Studio Session</option>
                    <option value="Online Session">Online Session</option>
                    <option value="Private Session">Private Session</option>
                </select>
            </div>

            <div className='d-flex align-items-center justify-content-center  '>

                <button
                    disabled={isDisable}
                    onClick={handleEnquiry}
                    style={isDisable ? {background:"linear-gradient(90.56deg, #F21623 -27.33%, #EA4B54 137.21%)",opacity:"0.2"} : {background:"linear-gradient(90.56deg, #F21623 -27.33%, #EA4B54 137.21%)"}}
                    className='proceedBtn downloadEbookBtn disableDownloadEbookBtn'>
                    Submit
                </button>

            </div>
        </div>
        </div>
        </Modal.Body>
    </Modal>
</div>
  )
}

export default EnquiryForm